import { render, staticRenderFns } from "./TableTd.vue?vue&type=template&id=21e6b81c&scoped=true"
import script from "./TableTd.vue?vue&type=script&lang=js"
export * from "./TableTd.vue?vue&type=script&lang=js"
import style0 from "./TableTd.vue?vue&type=style&index=0&id=21e6b81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6b81c",
  null
  
)

export default component.exports